import { Card, Section } from "@snpjs/core";

import { AsyncLoad } from "../../components/asyncLoad/AsyncLoad";
import { InstallGuideButton } from "../../features/installGuide/InstallGuideButton";
import Markdown from "react-markdown";
import { MissingInstallGuideError } from "../../api/errors/MissingInstallGuideError";
import { PublicPage } from "../../components/pages/publicPage/PublicPage";
import { SystemApi } from "../../api/SystemApi";
import remarkGfm from "remark-gfm";
import styles from "./InstallationChecklistPage.module.scss";
import { texts } from "../../i18n/texts";
import { useRequest } from "../../hooks/useRequest";
import { useRouteParam } from "../../hooks/useRouteParam";
import { useState } from "react";
import useTranslation from "../../hooks/useTranslation";

export const InstallationChecklistPage: React.FC = () => {
  const request = useRequest();
  const objectId = useRouteParam<string>("systemId");
  const checksumSha1 = useRouteParam<string>("checksumSha1");

  const [displayError, setDisplayError] = useState(false);
  const [content, setContent] = useState("");
  const { t } = useTranslation();

  return (
    <PublicPage
      className={styles.center}
      iconName="clipboard-checklist"
      showPageInfo={false}
    >
      <AsyncLoad
        load={async () => {
          await request.send(
            async () => {
              const content = await SystemApi.findInstallChecklistPublic(
                objectId,
                checksumSha1
              );
              setContent(content);
            },
            (error) => {
              if (error instanceof MissingInstallGuideError) {
                setDisplayError(true);
                return true;
              }
              return false;
            }
          );
        }}
      >
        {displayError && (
          <h3>{t(texts.installChecklist.errorLoadingInstallChecklist)}</h3>
        )}
        <div className={styles.center}>
          <Section
            icon="list-checks"
            title={t(texts.installChecklist.title)}
            rightElement={
              <InstallGuideButton
                objectId={objectId}
                checksumSha1={checksumSha1}
              />
            }
          >
            <Card>
              <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
            </Card>
          </Section>
        </div>
      </AsyncLoad>
    </PublicPage>
  );
};
